import { render, staticRenderFns } from "./keyWords.vue?vue&type=template&id=7a1899dc&scoped=true&"
import script from "./keyWords.vue?vue&type=script&lang=js&"
export * from "./keyWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1899dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1899dc')) {
      api.createRecord('7a1899dc', component.options)
    } else {
      api.reload('7a1899dc', component.options)
    }
    module.hot.accept("./keyWords.vue?vue&type=template&id=7a1899dc&scoped=true&", function () {
      api.rerender('7a1899dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonKeyWords/keyWords.vue"
export default component.exports